export const parcelPresentationTypes = {
  rows: 'rows',
  list: 'list',
}
